<div class="w-full">
  @if (label) {
    <label class="mb-1 block text-sm font-medium !text-slate800">
      {{ label }}
      @if (required) {
        <span class="text-red600">*</span>
      }
    </label>
  }

  <div class="grid gap-3" [ngClass]="showDays ? 'grid-cols-3' : 'grid-cols-2'">
    <div>
      <input
        type="number"
        min="0"
        max="99"
        [placeholder]="yearsPlaceholder"
        [formControl]="yearsControl"
        [readonly]="disabled"
        (keydown)="preventNegative($event)"
        (input)="onYearsChange($event)"
        (change)="onYearsChange($event)"
        class="w-full rounded-md bg-slate-50 border text-slate800 border-slate-300 placeholder:text-slate-400 placeholder:opacity-100 focus:outline-none focus:border-indigo700 disabled:cursor-not-allowed [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&[type=number]]:[appearance:textfield]"
        [ngClass]="inputClassMap"
        [class.border-red500]="yearsShouldShowError"
      />
      <div class="mt-1">
        @if (yearsShouldShowError) {
          <p class="text-xs text-red600">{{ yearsErrorMessage }}</p>
        }
      </div>
    </div>

    <div>
      <input
        type="number"
        min="0"
        max="11"
        [placeholder]="monthsPlaceholder"
        [formControl]="monthsControl"
        [readonly]="disabled"
        (keydown)="preventNegative($event)"
        (input)="onMonthsChange($event)"
        (change)="onMonthsChange($event)"
        class="w-full rounded-md bg-slate-50 border text-slate800 border-slate-300 placeholder:text-slate-400 placeholder:opacity-100 focus:outline-none focus:border-indigo700 disabled:cursor-not-allowed [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&[type=number]]:[appearance:textfield]"
        [ngClass]="inputClassMap"
        [class.border-red500]="monthsShouldShowError"
      />
      <div class="mt-1">
        @if (monthsShouldShowError) {
          <p class="text-xs text-red600">{{ monthsErrorMessage }}</p>
        }
      </div>
    </div>

    @if (showDays) {
      <div>
        <input
          type="number"
          min="0"
          max="30"
          [placeholder]="daysPlaceholder"
          [formControl]="daysControl"
          [readonly]="disabled"
          (keydown)="preventNegative($event)"
          (input)="onDaysChange($event)"
          (change)="onDaysChange($event)"
          class="w-full rounded-md bg-slate-50 border text-slate800 border-slate-300 placeholder:text-slate-400 placeholder:opacity-100 focus:outline-none focus:border-indigo700 disabled:cursor-not-allowed [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&[type=number]]:[appearance:textfield]"
          [ngClass]="inputClassMap"
          [class.border-red500]="daysShouldShowError"
        />
        <div class="mt-1">
          @if (daysShouldShowError) {
            <p class="text-xs text-red600">{{ daysErrorMessage }}</p>
          }
        </div>
      </div>
    }
  </div>
</div>
